class Authorizer {
  id = null

  name = ''

  weight = 1.0

  created_at = null

  updated_at = null

  constructor(options = {}) {
    Object.assign(this, options)
  }

  // let authorizer = (new Authorizer).fill({ name: "Acme d.o.o.", weight: 1.00 });
  fill(options) {
    return Object.assign(this, options)
  }
}

export default Authorizer
